import { render } from "./LoginRegister.vue?vue&type=template&id=000e7aae&scoped=true"
import script from "./LoginRegister.vue?vue&type=script&lang=js"
export * from "./LoginRegister.vue?vue&type=script&lang=js"

import "./LoginRegister.vue?vue&type=style&index=0&id=000e7aae&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000e7aae"]])

export default __exports__